"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const react_i18next_1 = require("react-i18next");
const theme_1 = __importDefault(require("../../styles/theme"));
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const webViewer_1 = __importDefault(require("../../components/webViewer/webViewer"));
const loanApplicationSlice_1 = require("../loanApplication/loanApplicationSlice");
const logo_1 = __importDefault(require("../../components/logo/logo"));
const constants_1 = require("../../constants/constants");
const store_1 = require("../../store");
const homeSlice_1 = require("../home/homeSlice");
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const text_1 = __importStar(require("../../components/text/text"));
const appMessages_1 = __importDefault(require("../../components/appMessage/appMessages"));
const icon_1 = require("../../components/icon/icon");
const styles_1 = __importDefault(require("../../styles/styles"));
const analytics_1 = require("../../utils/analytics/analytics");
const PartnerOfferLetter = ({ route }) => {
    const { params } = route;
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const loanApplicationId = (0, store_1.useAppSelector)((state) => state.loanApplication.loan_application_id);
    const [offerLetter, setOfferLetter] = (0, react_1.useState)(null);
    const [rawPartnerName, setPartnerName] = (0, react_1.useState)('');
    const getLoanOffer = async () => {
        const result = await dispatch((0, loanApplicationSlice_1.getLoanOfferApi)({ loanApplicationId }));
        logEventWithExtraProperties('api_call', {
            name: 'get_offer_letter_url',
            status: 'submitted',
            location: 'screen_PartnerOfferLetter',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'get_offer_letter_url',
                status: 'success',
                location: 'screen_PartnerOfferLetter',
            });
            setOfferLetter(result.payload);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'get_offer_letter_url',
                status: 'fail',
                location: 'screen_PartnerOfferLetter',
            });
        }
    };
    (0, react_1.useEffect)(() => {
        getLoanOffer();
        setPartnerName(params.partner !== undefined && params.partner !== '' ? params.partner : '');
    }, []);
    const partnerName = rawPartnerName.replace(/_+/, ' ');
    const loanOfferResponse = async (answer) => {
        const payload = {
            decision: answer ? 'approve' : 'reject',
            loanApplicationId,
        };
        dispatch((0, loanApplicationSlice_1.answerLoanOffer)(payload));
        dispatch((0, homeSlice_1.addMessages)([
            {
                title: `Partnership with ${params.partner !== undefined && params.partner !== '' ? partnerName : 'Jumia'}`,
                message: params.partner !== undefined && params.partner !== ''
                    ? constants_1.APP_MESSAGES.PARTNERSHIP_OFFER_LETTER_PARTNER
                    : constants_1.APP_MESSAGES.JUMIA_OFFER_LETTER_PARTNER,
                iconType: icon_1.GREEN_CHECK_CIRCLE,
                iconColor: theme_1.default.colors.COLOR_PRIMARY,
                iconSize: 200,
                buttonText: params.partner !== undefined && params.partner !== '' ? '' : 'RETURN TO PARTNER',
                otherActionUrl: params.partner !== undefined && params.partner !== '' ? '' : 'https://pay.jumia.com.ng/',
                hasLogo: true,
            },
        ]));
        dispatch((0, homeSlice_1.showMessage)());
    };
    let content = react_1.default.createElement(spinner_1.default, null);
    if (offerLetter) {
        content = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.centerChildHorizontalVertical },
                react_1.default.createElement(logo_1.default, { fixedSize: true })),
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, `Partnership with ${params.partner !== undefined && params.partner !== '' ? partnerName : 'Jumia'}`),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.centerChildHorizontalVertical },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE, color: theme_1.default.colors.COLOR_GRAY_DARK }, t('jumia.offerLetter.loan_offer'))),
            react_1.default.createElement(webViewer_1.default, { docSrc: offerLetter.offer_letter }),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow] },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                    react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Accept", onPress: () => loanOfferResponse(true), eventName: "partner_loan_offer_accept_offer" })),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                    react_1.default.createElement(primaryButton_1.default, { disabled: false, color: theme_1.default.colors.COLOR_CRITICAL, title: "Decline", onPress: () => loanOfferResponse(false), eventName: "partner_loan_offer_decline_offer" })))));
    }
    return react_1.default.createElement(appMessages_1.default, { isHomeContainer: false }, content);
};
exports.default = PartnerOfferLetter;
